import { Box } from '@mui/material';
import { sanitizeRichTextHtml } from '../../utils/sanitizeHtml';

interface IHTMLContentProps {
  content: string;
}

const HTMLContent = ({ content }: IHTMLContentProps) => {
  const sanitizedContent = sanitizeRichTextHtml(content);

  return (
    <Box
      lineHeight={'20.3px'}
      sx={{
        textAlign: 'justify',
        width: { xs: '100%', lg: '85%' },
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          fontWeight: 600,
          lineHeight: '1.2',
        },
        '& h1': {
          fontSize: '24px',
        },
        '& h2': {
          fontSize: '20px',
        },
        '& h3': {
          fontSize: '16px',
        },
        '& p': {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '1.5',
          display: 'inline',
        },
        '& ul, ol': {
          listStylePosition: 'inside',
          '& li::marker': {
            color: 'text.primary',
          },
        },
        '& ul': {
          listStyleType: 'disc',
          '& p': {
            marginLeft: '-2px',
          },
        },
      }}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    ></Box>
  );
};

export default HTMLContent;
